import { jsonToFormData } from 'client/utils/helpers/Enquiry/Enquiry';

const trimIfString = (value) => {
    if (typeof value !== 'string') {
        return value;
    }

    const trimmed = value.trim();
    return trimmed.length ? trimmed : null;
};

const normaliseDescription = (description, fallback) => {
    const primary = trimIfString(description);
    if (primary) {
        return primary;
    }

    const fallbackValue = trimIfString(fallback);
    return fallbackValue || null;
};

export const buildEnquiryDraftFormData = ({
    geometry,
    title,
    description,
    jobReference,
    activityType,
    isEmergency,
    utilityEnquiryType,
    startDate,
    endDate
} = {}) => {
    const payload = { draft: true };

    if (geometry) {
        payload.geometry = geometry;
    }

    const safeTitle = trimIfString(title);
    if (safeTitle) {
        payload.title = safeTitle;
    }

    const safeDescription = normaliseDescription(description, title);
    if (safeDescription) {
        payload.description = safeDescription;
    }

    const safeJobReference = trimIfString(jobReference);
    if (safeJobReference) {
        payload.jobReference = safeJobReference;
    }

    const safeActivityType = trimIfString(activityType);
    if (safeActivityType) {
        payload.activityType = safeActivityType;
    }

    if (typeof isEmergency === 'boolean') {
        payload.isEmergency = isEmergency;
    }

    const safeUtilityEnquiryType = trimIfString(utilityEnquiryType);
    if (safeUtilityEnquiryType) {
        payload.utilityEnquiryType = safeUtilityEnquiryType;
    }

    if (startDate) {
        payload.startDate = startDate;
    }

    if (endDate) {
        payload.endDate = endDate;
    }

    return jsonToFormData(payload);
};

export default buildEnquiryDraftFormData;
